import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getAllActiveBlogs,
  getBlogByBlogURL,
  getBlogByID,
} from "./services/blog.services";
import { IBlogInitialState } from "./blogModel";

const initialState: IBlogInitialState = {
  loading: false,
  error: "",
  BlogDetails: {},
  BlogList: [],
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    clearBlogDetails: (state) => {
      state.BlogDetails = initialState.BlogDetails;
    },
    setBlogDetails: (state, action: PayloadAction<any>) => {
      state.BlogDetails = action.payload;
      state.loading = false;
    },
    setBlogList: (state, action: PayloadAction<any[]>) => {
      state.BlogList = action.payload || [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveBlogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveBlogs.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllActiveBlogs.rejected, (state, action) => {
      state.loading = false;
      state.BlogList = initialState.BlogList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBlogByID.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlogByID.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBlogByID.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetails = initialState.BlogDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBlogByBlogURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlogByBlogURL.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBlogByBlogURL.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetails = initialState.BlogDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default blogSlice.reducer;
export const { clearBlogDetails, setBlogDetails, setBlogList } =
  blogSlice.actions;
